import {
  cn
} from "./chunk-SBEJSA5Q.js";

// src/components/ui/progress.tsx
import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var progressVariants = cva(
  "bg-muted relative w-full overflow-hidden rounded-full",
  {
    variants: {
      size: {
        sm: "h-1",
        md: "h-2",
        lg: "h-3",
        xl: "h-4"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
var Progress = React.forwardRef(({ className, value, size, ...props }, ref) => {
  const progressSize = size || "md";
  return /* @__PURE__ */ jsx(
    ProgressPrimitive.Root,
    {
      ref,
      value,
      "data-slot": "progress",
      className: cn(progressVariants({ size: progressSize }), className),
      ...props,
      children: /* @__PURE__ */ jsx(
        ProgressPrimitive.Indicator,
        {
          "data-slot": "progress-indicator",
          className: "bg-primary h-full w-full flex-1 transition-all",
          style: { transform: `translateX(-${100 - (value || 0)}%)` }
        }
      )
    }
  );
});
Progress.displayName = "Progress";

export {
  progressVariants,
  Progress
};
//# sourceMappingURL=chunk-5A2ZTJPT.js.map